import { useEffect, useState } from 'react';
import { HOTSPOTS } from './hotspotData';
import './HotspotModal.scss';

export default function HotspotModal({ isOpen, currentIndex, onClose }) {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (isOpen) {
            // Pequeño delay para permitir que el DOM se renderice antes de agregar la clase active
            const timer = setTimeout(() => {
                setIsActive(true);
            }, 10);
            return () => clearTimeout(timer);
        } else {
            setIsActive(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const currentHotspot = HOTSPOTS[currentIndex];

    return (
        <div className={`hotspot-modal-overlay ${isActive ? 'active' : ''}`}>
            <div 
                className="hotspot-modal-card"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="hotspot-modal-card__image-container">
                    <img 
                        src={currentHotspot?.content?.img} 
                        alt={currentHotspot?.content?.title}
                        className="hotspot-modal-card__image"
                    />
                    <button 
                        className="hotspot-modal-card__close-btn"
                        onClick={onClose}
                    >
                        <img src="/images/experiences/int/close_small.svg" alt="Close" />
                    </button>
                </div>
                <div className="hotspot-modal-card__content">
                    <h2 className="hotspot-modal-card__title">
                        {currentHotspot?.content?.title}
                    </h2>
                    <p 
                        className="hotspot-modal-card__description"
                        dangerouslySetInnerHTML={{ 
                            __html: currentHotspot?.content?.description 
                        }}
                    />
                </div>
            </div>
        </div>
    );
}